import React, { useState, useCallback, useEffect } from "react";

import { Dropdown } from "react-bootstrap";

import * as firebase from "firebase/app";

import { useDocumentData } from "react-firebase-hooks/firestore";

const NewPostForm = (props) => {
  const [gameData] = useDocumentData(
    firebase.firestore().doc(`games/${props.selectGameId}`)
  );

  const [selectLevel, setSelectLevel] = useState("");
  const [selectPlatform, setSelectPlatform] = useState("");
  const [selectDescription, setSelectDescription] = useState("");
  const [oldSelectGame, setOldSelectGame] = useState();

  useEffect(() => {
    if (props.selectGameId !== oldSelectGame) {
      setOldSelectGame(props.selectGameId);
      setSelectLevel("");
      setSelectPlatform("");
    }
  }, [props.selectGameId, oldSelectGame]);

  useEffect(() => {
    if (props.postValue) {
      setSelectLevel(props.postValue.level);
      setSelectPlatform(props.postValue.platform);
      setSelectDescription(props.postValue.description);
    }
  }, [props.postValue]);

  const createPost = useCallback(() => {
    const db = firebase.firestore();

    let game_vignette;

    props.gamesList.forEach((game) => {
      if (game.game_id === props.selectGameId) {
        game_vignette = game.vignette_url;
      }
    });

    if (props.postValue) {
      db.doc(`posts/${props.postValue.id}`).update({
        game: gameData.game,
        id_game: props.selectGameId,
        platform: selectPlatform,
        level: selectLevel,
        description: selectDescription,
        game_vignette: game_vignette,
      });

      let chatTitle =
        gameData.game + " - " + selectPlatform + " - " + selectLevel;

      db.doc(`chats/${props.postValue.id_chat}`).update({
        vignette: game_vignette,
        chatTitle: chatTitle,
      });
    } else {
      let date = new Date();

      let date_day = date.getDate();
      if (date_day < 10) {
        date_day = "0" + date_day;
      }
      let date_month = date.getMonth() + 1;
      if (date_month < 10) {
        date_month = "0" + date_month;
      }
      let date_year = date.getFullYear();
      let date_hour = date.getHours();
      if (date_hour < 10) {
        date_hour = "0" + date_hour;
      }
      let date_minute = date.getMinutes();
      if (date_minute < 10) {
        date_minute = "0" + date_minute;
      }

      let stringDate =
        date_day +
        "/" +
        date_month +
        "/" +
        date_year +
        " - " +
        date_hour +
        ":" +
        date_minute;

      db.collection("posts")
        .add({
          empty: "empty",
          id_user: props.userId,
          pseudo_user: props.valueUserInfo.pseudo,
          user_nbr: 1,
          game: gameData.game,
          id_game: props.selectGameId,
          platform: selectPlatform,
          level: selectLevel,
          description: selectDescription,
          date: stringDate,
          id_gamesList: gameData.gamesList_id,
          game_vignette: game_vignette,
        })
        .then((refPost) => {
          db.doc(`posts/${refPost.id}`).update({
            id: refPost.id,
          });

          let chatTitle =
            gameData.game + " - " + selectPlatform + " - " + selectLevel;

          db.collection("chats")
            .add({
              chatTitle: chatTitle,
              users: [{ id: props.userId, pseudo: props.valueUserInfo.pseudo }],
              nbr_users: 1,
              vignette: game_vignette,
              id_post: refPost.id,
            })
            .then((refChat) => {
              db.doc(`chats/${refChat.id}`).update({
                id: refChat.id,
              });
              db.doc(`posts/${refPost.id}`).update({
                id_chat: refChat.id,
              });
              let usersChatsList = props.valueUserInfo.mates;
              usersChatsList.push(refChat.id);
              let usersPostList = props.valueUserInfo.posts;
              usersPostList.push(refPost.id);
              db.doc(`users/${props.userId}`).update({
                posts: usersPostList,
                mates: usersChatsList,
              });
            });
        });

      const increment = firebase.firestore.FieldValue.increment(1);
      db.doc(`gamesList/${gameData.gamesList_id}`).update({
        nbr_posts: increment,
      });
    }

    props.setNewPostTrigger(false);
  }, [gameData, props, selectPlatform, selectLevel, selectDescription]);

  return (
    <>
      <div className="newPost__el">
        <h3 className="newPost__subTitle">Platforme</h3>
        <Dropdown>
          <Dropdown.Toggle className="newPost__dropdown" as={"button"}>
            {!selectPlatform ? "Platforme" : selectPlatform}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Header>Choisir une platforme</Dropdown.Header>
            <ul>
              <Dropdown.Item as={"li"} onClick={() => setSelectPlatform("")}>
                Aucun
              </Dropdown.Item>
              {gameData &&
                gameData.consoles.map((value, key) => (
                  <Dropdown.Item
                    as={"li"}
                    onClick={() => setSelectPlatform(value)}
                    key={key}
                  >
                    {value}
                  </Dropdown.Item>
                ))}
            </ul>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className="newPost__el">
        <h3 className="newPost__subTitle">Niveau / Rang</h3>
        <Dropdown>
          <Dropdown.Toggle className="newPost__dropdown" as={"button"}>
            {!selectLevel ? "Niveau" : selectLevel}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Header>Choisir un Niveau</Dropdown.Header>
            <ul>
              <Dropdown.Item as={"li"} onClick={() => setSelectLevel("")}>
                Aucun
              </Dropdown.Item>
              {gameData &&
                gameData.levels.map((value, key) => (
                  <Dropdown.Item
                    as={"li"}
                    onClick={() => setSelectLevel(value)}
                    key={key}
                  >
                    {value}
                  </Dropdown.Item>
                ))}
            </ul>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className="newPost__el">
        <h3 className="newPost__subTitle">Description</h3>
        <textarea
          onChange={(e) => setSelectDescription(e.target.value)}
          rows="4"
          className="newPost__text"
          placeholder="Description"
          value={selectDescription}
        />
      </div>
      <button onClick={() => createPost()} className="newPost__btnAdd">
        Envoyer
      </button>
    </>
  );
};

export default NewPostForm;
